module.exports = __webpack_public_path__ + "img/warning-high.540f6b65.svg";